// /dashboard — ActiveFrameworksDashboard. V1 demo = empty state.
// Real dashboard content lands in Phase D.

import { useNavigate } from 'react-router-dom';
import { Button } from '@gc-coach/design-system';
import { EmptyState } from '../shell/index.js';
import { useSession } from '../auth/index.js';
import { useI18n } from '../i18n/index.js';

export function DashboardPage() {
  const { t, tt } = useI18n();
  const navigate = useNavigate();
  const { session } = useSession();
  const firstName = (session?.displayName?.split(' ')[0] ?? '').trim();

  return (
    <EmptyState
      eyebrow={t('shell.dashboard.eyebrow')}
      headline={
        firstName
          ? tt('shell.dashboard.headlineNamed', { firstName })
          : t('shell.dashboard.headlineFallback')
      }
      body={t('shell.dashboard.body')}
      primary={
        <Button kind="primary" onClick={() => navigate('/frameworks')}>
          {t('shell.dashboard.primaryCta')}
        </Button>
      }
      secondary={
        <Button kind="ghost" disabled>
          {t('shell.dashboard.secondaryCta')}
        </Button>
      }
    />
  );
}
